
import { Options, prop, Vue } from "vue-class-component";

class Props {
  shouldShow = prop<boolean>({
    default: false,
    type: Boolean
  });
}

@Options({
  components: {}
})
export default class AIAssessmentBanner extends Vue.with(Props) {}
